import { router } from "@smakecloud/api-client-helper";
import { forgotPassword } from "./forgotPassword";
import { login } from "./login";
import { refresh } from "./refresh";
import { resetPassword } from "./resetPassword";

export const auth = router({ forgotPassword, login, refresh, resetPassword });
